import useFeatures from 'hooks/useFeatures';
import useLanguageCode from '@alltrails/shared/hooks/useLanguageCode';
import useUser from 'hooks/useUser';

export default function useAdaChatbot(experimentEnabled = false): {
  isAdaReady: boolean;
  config: {
    handle: string | null;
    language: string;
  };
} {
  const features = useFeatures();
  const languageCode = useLanguageCode();
  const user = useUser();

  const isAdaReady = !!(experimentEnabled && features?.includes('ada_chatbot') && user);

  return {
    isAdaReady,
    config: {
      handle: __AT_DATA__.adaConfig.handle,
      language: languageCode
    }
  };
}
